'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (filters, metaData) {
    var title = void 0;

    if ((0, _isArray2.default)(filters) && filters.length) {
        title = '';

        var filterItems = void 0,
            i = void 0,
            l = void 0;

        filters.forEach(function (dimension, index, array) {
            filterItems = metaData.dimensions[dimension.dimension];

            if ((0, _isArray2.default)(filterItems)) {
                l = filterItems.length;
                var id = void 0;

                for (i = 0; i < l; i++) {
                    id = filterItems[i];

                    // if the value is present in items take the name to show from there
                    if (metaData.items[id]) {
                        title += metaData.items[id].name + (i < l - 1 ? ', ' : '');
                    }
                    // otherwise use the values directly
                    // this is a temporary fix to avoid app crashing when using filters with data items in EV
                    else {
                            title += metaData.items[dimension.dimension].name + ': ' + filterItems.join(', ');

                            break;
                        }
                }

                title += index < array.length - 1 ? ' - ' : '';
            }
        });
    }

    return title || null;
};

var _isArray = require('d2-utilizr/lib/isArray');

var _isArray2 = _interopRequireDefault(_isArray);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=getFilterTitle.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-charts-api/lib/config/adapters/dhis_highcharts/getFilterTitle.js
 ** module id = 75
 ** module chunks = 0 1
 **/